import React, { useState, useEffect, useRef, useContext } from 'react';
import '../../assets/css/views/login.css'
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/provider/UserProvider'
import { notify } from '../../utils/utils'
import img1 from '../../assets/images/logoTPRO.png';
import img2 from '../../assets/images/logoTPRO.png';
import img3 from '../../assets/images/logoTPRO.png';
import {Slideshow, Slide} from '../components/utils/SliderShow';
import logo from '../../assets/images/LogoATU-MuniCIP .png'

const generatePKCE = async () => {
	const array = new Uint8Array(32);
	window.crypto.getRandomValues(array);
	const codeVerifier = btoa(String.fromCharCode(...array))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/, "");

	const encoder = new TextEncoder();
	const data = encoder.encode(codeVerifier);
	const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);

	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const base64 = btoa(String.fromCharCode(...hashArray))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/, "");

	return { codeVerifier, codeChallenge: base64 };
};

export const Login = () => {
    const history = useHistory();


    const iniciarSesionConAbexa = async () => {
        const result = await generatePKCE();
		localStorage.setItem("pkce", JSON.stringify(result))

        const queryParameters = new URLSearchParams({
            response_type: "code",
            client_id: process.env.REACT_APP_WSO2IS_CLIENT_ID,
            redirect_uri: process.env.REACT_APP_REDIRECT_URI,
            scope: process.env.REACT_APP_WSO2IS_SCOPES,
            state: "ThisIsMyStateValue",
            code_challenge: result.codeChallenge,
            code_challenge_method: "S256",
            id_carga: Date.now(),
        })
        const urlRedirect = `${process.env.REACT_APP_WSO2IS_AUTHORIZATION}/authorize?${queryParameters}`

        try {
            window.location.href = urlRedirect;
        } catch (error) {
            console.error('Error en la solicitud:', error);
        }
    }   

    return (
    
        <div className="flex flex-col dark:bg-slate-900 h-screen">
                
            {/* BARRA SUPERIOR */}
            <div className="h-[80px] flex items-center justify-start lg:justify-center bg-[#003968]">
                <div className="flex-shrink-0 flex justify-center items-center w-[250px]" >
                    <img className="w-[90px] h-full block sm:w-52 w-auto cursor-pointer" src={logo} onClick={() => history.push('/')} alt="Workflow"/>
                </div>
            </div>
            {/* FIN BARRA SUPERIOR */}

            <div className="container flex justify-center items-center lg:h-[70%] border border-red-600 hidden">
                    <div className='flex flex-col  text-center ' >
                        <div className='flex lg:flex-col '></div>
                    </div>
                </div>

            <div className="grow container flex justify-center items-center gap-x-10">
                <div className="w-[350px] mb-[90px] lg:w-[80%] flex flex-col items-center justify-between">
                    <div className="" style ={{}}>
                        <img className='mb-6' src={logo} alt='' />
                    </div>
                    <div className="w-full border-2 border-[#002A78] rounded-2xl justify-center text-center items-center flex flex-col">
                        
                        <div className='text-center border-b-[#002A78]'>
                            <h2 className="dark:text-white text-2xl font-medium tracking-tight" >Iniciar Sesión</h2>
                        </div>
                        <div 
                            className='lg:w-[100px] text-xl bg-[#002A78] hover:bg-blue-700 p-2 dark:text-white border items-center w-[120px] m-[20px] rounded items-center text-center justify-center flex text-center cursor-pointer'
                            onClick={() => iniciarSesionConAbexa()}
                        >   
                            {/* <img className='boton-web rounded-2xl' src={btn3} alt=''/><label>Autoridad</label> */}
                            <button className='text-xl cursor-pointer' /><label className=' cursor-pointer ' >Autoridad</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


